import { Controller } from "@hotwired/stimulus"

// Small popover menu (e.g. the profile Block/Report overflow). Replaces the
// former Alpine x-data/x-show usage, which the production CSP blocks
// (no unsafe-eval) — that left the panel permanently visible over the profile.
//
// Markup:
//   <div data-controller="menu">
//     <button data-action="menu#toggle">…</button>
//     <div data-menu-target="panel" hidden>
//       <button data-action="menu#openDialog" data-menu-dialog-param="report-modal-1">Report</button>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.close()
    this._onDocClick = (e) => { if (!this.element.contains(e.target)) this.close() }
    this._onKey = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("click", this._onDocClick)
    document.addEventListener("keydown", this._onKey)
  }

  disconnect() {
    document.removeEventListener("click", this._onDocClick)
    document.removeEventListener("keydown", this._onKey)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.hasPanelTarget) this.panelTarget.hidden = !this.panelTarget.hidden
  }

  close() {
    if (this.hasPanelTarget) this.panelTarget.hidden = true
  }

  // Open a <dialog> by id (data-menu-dialog-param) and close the menu.
  openDialog(event) {
    const id = event.params.dialog
    const dialog = id && document.getElementById(id)
    if (dialog && typeof dialog.showModal === "function") dialog.showModal()
    this.close()
  }
}
